
import GenderIcon from './gender-icon'
import Datetime from '../../admin/components/datetime'
export default
    name: 'live-finish-oneline'
    components: {GenderIcon, Datetime}
    props:
        href: String
        race_id: Number
    data: ->
        heats: [{bib: '-', name: '', result: '', rank_abs: '-', rank_gender: '-', gender: 0}]
        limit: 10
    channels:
        LiveFinishChannel:
            received: (data) ->
                if data.heat?
                    @heats.unshift(data.heat)
                    @heats.pop() if @limit < @heats.length
                if data.action?
                    @refresh() if 'update' == data.action
    mounted: ->
        @refresh()
        if @race_id?
            @$cable.subscribe({channel: 'LiveFinishChannel', race_id: @race_id})

    methods:
        refresh: ->
            @axios.get(@href)
                .then (res) => (@heats = res.data.heats)
                .catch (e) -> console.log e


